module.exports = __webpack_public_path__ + "static/media/GuestMe-Bell.6d121e93.wav";